import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  Divider,
} from '@mui/material';
import { useAppBar } from '../../providers/AppBarProvider';
import { handleError, formatCurrency, formatDate2 } from '../../utils/lib';
import { useLocation, useNavigate } from 'react-router-dom';
import ViewPage from './ViewPage';
import { useSnackbar } from "../../providers/SnackBarProvider";
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function ViewOwnerDebts() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const [id, setId] = useState(location.state.id);
  const [name, setName] = useState(location.state.name);
  const [thumb_url, setThumbUrl] = useState(location.state.thumb_url);
  const [ownerDebts, setOwnerDebts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {updateTitle} = useAppBar();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = {
          id_owner: id,
          owner_debt_details: '',
        };
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}finance`,
          { params: params, withCredentials: true },
        );
        setOwnerDebts(response.data.data);
        //console.log(response.data.data);
        updateTitle(thumb_url || '', t('view.ownerDebtsPageTitle'), name);
      } catch (error) {
        handleError(error, snackbar);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [t]);

  const handleDebtClick = (debt) => {
    navigate('/main/view-sell', { state: { id: debt.id } });
  };

  return (
    <ViewPage 
      isLoading={isLoading}
    >
      <Box sx={{ px: 1 }}>
        <List>
          {ownerDebts.map((debt, index) => (
            <React.Fragment key={debt.id}>
              <ListItem
                onClick={() => handleDebtClick(debt)}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  py: 2,
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'action.hover',
                  },
                }}
              >
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  width: '100%',
                  mb: 1
                }}>
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      {formatDate2(debt.date)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t('view.receiptLabel')} {`${debt.finance_types_receipt.short_denomination}${debt.sell_point_number}-${debt.receipt_number}`}
                    </Typography>
                    {debt.owner && (
                      <Typography variant="body2" color="text.secondary">
                        {t('view.invoiceTo', { name: debt.owner.name })}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ textAlign: 'right' }}>
                    <Typography variant="body2" color="text.secondary">
                      {t('view.totalLabel')} {formatCurrency(debt.total)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t('view.balanceLabel')} {formatCurrency(debt.balance)}
                    </Typography>
                  </Box>
                </Box>
              </ListItem>
              {index < ownerDebts.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Box>
    </ViewPage>
  );
}

export default ViewOwnerDebts;

